import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TokenStorageService } from '../services/token-storage.service';
import { NbToastrService } from '@nebular/theme';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  
  constructor(
    private tokenStorage: TokenStorageService,
    private toastr: NbToastrService // 🔥 Toaster inject kiya
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.tokenStorage.getToken();
    
    if (request.body instanceof FormData) {
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`)
      });
    } else {
      request = request.clone({
        headers: request.headers
          .set('Content-Type', 'application/json')
          .set('Authorization', `Bearer ${token}`)
      });
    }
    
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          this.toastr.danger(
            'You do not have permission to perform this action. Contact Administrator.', 
            'Access Denied!', 
            { duration: 4000 }
          );
        }
        return throwError(() => error);
      })
    );
  }
}